//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'VistatNuxtLoader',
  data() {
    return {
      loading: false,
      progress: 0,
      interval: null,
    }
  },
  computed: {
    isSpecialProjectPage() {
      return this.$route?.name === 'sp-slug'
    },
  },
  methods: {
    start() {
      this.loading = true
      this.progress = 0
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        if (this.progress < 88) {
          this.progress += Math.max(1, (90 - this.progress) * 0.12)
        }
      }, 120)
    },
    set(progress) {
      this.progress = Math.max(this.progress, progress)
    },
    finish() {
      this.progress = 100
      clearInterval(this.interval)
      setTimeout(() => {
        this.loading = false
        this.progress = 0
      }, 260)
    },
    fail() {
      this.finish()
    },
    increase(num) {
      this.progress = Math.min(99, this.progress + num)
    },
  },
}
